export default class Guid {
    public static randomGuid() {
        let g = '';
        for (let i = 0; i < 8; i++) {
          g += i > 1 && i < 6 ? '-' : '';
          g += Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
        return g;
    }

    public static guidValidationRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    public static isGuid(value: string) {
        return Guid.guidValidationRegex.test(value);
    }
}
